module.exports = "/images/bg-home.jpg?4122be766ef46011ed6cbc43a641e79b";